import { Box, Typography } from '@mui/material';
import { BasicPage } from '../page-templates/BasicPage/BasicPage';

export const NotFoundPage: React.FC = () => {
  return (
    <BasicPage>
      <Box
        sx={{
          minHeight: '70vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
          }}
        >
          {/* 404 Number */}
          <Typography
            variant="h1"
            sx={{
              fontSize: '8rem',
              fontWeight: 'bold',
              color: 'text.primary',
              lineHeight: 1,
              mb: 2,
            }}
          >
            404
          </Typography>

          {/* Error Message */}
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 'medium',
              color: 'text.primary',
              mb: 1,
            }}
          >
            Page Not Found
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'text.secondary',
              mb: 4,
              maxWidth: '400px',
            }}
          >
            The page you're looking for doesn't exist. It might have been moved,
            deleted, or you entered the wrong URL.
          </Typography>

          {/* Additional Help */}
          <Typography
            variant="body2"
            sx={{
              color: 'text.disabled',
              mt: 4,
              maxWidth: '500px',
            }}
          >
            If you believe this is an error, please contact support or check the
            URL you entered.
          </Typography>
        </Box>
      </Box>
    </BasicPage>
  );
};
